import { StyleSheet } from "react-native";

export const CORES = {
  fundo: "#F4F0E8",
  card: "#ffffff",
  borda: "rgba(0,0,0,0.06)",
  titulo: "#1d1d1d",
  subtitulo: "#7c7c7c",
  progressoVazio: "rgba(0,0,0,0.08)",
};

export const sombraCard = {
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: 0.05,
  shadowRadius: 10,
  elevation: 2,
};

export default StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.fundo,
  },
  larguraConteudo: {
    width: "100%",
    maxWidth: 560,
    paddingHorizontal: 16,
  },

  // Barra superior
  barraSuperior: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 14,
  },
  botaoQuadrado: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
    alignItems: "center",
    justifyContent: "center",
    ...sombraCard,
  },
  espacoBotao: {
    width: 40,
    height: 40,
  },
  contador: {
    alignItems: "flex-end",
    justifyContent: "center",
  },
  textoContador: {
    fontSize: 13,
    fontWeight: "700",
    color: CORES.titulo,
  },
  linhaAviso: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    marginBottom: 10,
  },
  textoAviso: {
    fontSize: 12,
    color: CORES.subtitulo,
  },
  textoEtapa: {
    fontSize: 13,
    color: CORES.subtitulo,
    fontWeight: "500",
  },

  // Progresso
  linhaProgresso: {
    flexDirection: "row",
    gap: 6,
    marginTop: 14,
  },
  segmentoProgresso: {
    flex: 1,
    height: 4,
    borderRadius: 2,
  },

  // Título
  titulo: {
    fontSize: 28,
    lineHeight: 32,
    fontWeight: "800",
    color: CORES.titulo,
    marginTop: 22,
  },
  subtitulo: {
    fontSize: 14,
    color: CORES.subtitulo,
    marginTop: 8,
  },
  filtro: {
    marginTop: 18,
  },

  // Conteúdo
  scroll: {
    flex: 1,
    width: "100%",
  },
  scrollConteudo: {
    alignItems: "center",
    paddingTop: 14,
    paddingBottom: 24,
  },

  // Rodapé
  rodape: {
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.card,
    paddingTop: 14,
    paddingBottom: 18,
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 8,
  },
  linhaRodape: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
  },
  resumo: {
    flexShrink: 1,
  },
  resumoRotulo: {
    fontSize: 12,
    color: CORES.subtitulo,
  },
  resumoValor: {
    fontSize: 20,
    fontWeight: "800",
    color: CORES.titulo,
  },
  botaoPrincipal: {
    flex: 1,
    height: 52,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingHorizontal: 16,
  },
  textoBotaoPrincipal: {
    fontSize: 16,
    fontWeight: "700",
  },
});
